import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/* eslint-disable */
import { EEstimationTargets } from '../../types';
import { validateFlatFilters } from './validateFlatFilters';
import { validateHouseFilters } from './validateHouseFilters';
import { validateJKFilters } from './validateJKFilters';
import { validateLandFilters } from './validateLandFilters';
/**
 * Санк для валидации фильтров оценки
 * В зависимости от типа оцениваемой недвижимости, будет выбран валидатор
 * Для Квартир выбирается валидатор квартир, для ЖК - соответственно
 * */

export var validateFilters = function validateFilters() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState, estimationTarget;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), estimationTarget = _getState.filters.estimationTarget;
              _context.t0 = estimationTarget;
              _context.next = _context.t0 === EEstimationTargets.flat ? 4 : _context.t0 === EEstimationTargets.house ? 5 : _context.t0 === EEstimationTargets.land ? 6 : _context.t0 === EEstimationTargets.newbuilding ? 7 : 8;
              break;

            case 4:
              return _context.abrupt("return", dispatch(validateFlatFilters()));

            case 5:
              return _context.abrupt("return", dispatch(validateHouseFilters()));

            case 6:
              return _context.abrupt("return", dispatch(validateLandFilters()));

            case 7:
              return _context.abrupt("return", dispatch(validateJKFilters()));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};